<template>
    <grid
        ref="grid"
        :is-auto-height="true"
        :is-search="false"
        :with-space="false"
        :columnDefs="columnDefs"
        :rowData="propertiesAreas"
    ></grid>
</template>

<script>
    import Grid from '../../generic/grid/grid.vue';

    export default {
        name: 'PropertiesAreaList',
        components: {
            Grid,
        },
        props: {
            embeddedPage: Object,
            propertiesAreas: Array,
        },
        data() {
            return {
                columnDefs: [
                    {
                        field: 'area',
                        headerName: 'Category',
                    },
                    {
                        type: 'switchColumn',
                        headerName: 'Display',
                        cellClass: 'ag-right-aligned-cell',
                        headerClass: 'ag-right-aligned-header',
                        valueGetter: ({ data }) => !this.embeddedPage.disabled_areas.includes(data.id),
                        cellRendererParams: {
                            onChange: async ({ node, api }, newValue) => {
                                const enable = newValue;
                                const enableDisableText = enable ? 'enable' : 'disable';

                                api.showLoadingOverlay();
                                try {
                                    await this.$store.dispatch('embeddedPage/enableDisableEmbeddedPagePropertiesArea', {
                                        id: this.embeddedPage.id,
                                        area_id: node.data.id,
                                        enable,
                                    })
                                    this.$emit('property-area-update-success');
                                } catch {
                                    this.errorToast({text: `Could not ${enableDisableText} properties area.`,})
                                    api.redrawRows({ rowNodes: [node] });
                                    return;
                                } finally {
                                    api.hideOverlay();
                                }
                            }
                        }
                    }
                ]
            }
        },
        watch: {
            embeddedPage() {
                this.$refs.grid.gridOptions.api.redrawRows();
            }
        }
    }
</script>

<style>
    .align-right .ag-header-cell-text {
        flex: 1;
        text-align: right !important;
    }
</style>
